import angular from 'angular'
import modal from 'ui-bootstrap4/src/modal'

import { EmploymentProcessingDashboardComponent } from './employment-processing-dashboard/employment-processing-dashboard.component';
import { EmploymentTimelineReportDownloadModalComponent } from './employment-processing-dashboard/employment-timeline-report-download-modal.component';
import { AdpNumberAssignmentComponent } from './adp-number-assignment.component';
import { ProcessTerminationsComponent } from './process-terminations.component';
import { NewHiresProcessor } from './new-hires-processor.service';
import { TerminationsProcessor } from './terminations-processor.service';

export const EmploymentProcessingModule = angular
    .module("apex.mainApp.employmentProcessing", [
        modal
    ])
    .component("apexEmploymentProcessingDashboard", EmploymentProcessingDashboardComponent)
    .component("apexEmploymentTimelineReportDownloadModal", EmploymentTimelineReportDownloadModalComponent)
    .component("apexAdpNumberAssignment", AdpNumberAssignmentComponent)
    .component("apexProcessTerminations", ProcessTerminationsComponent)
    .service("newHiresProcessor", NewHiresProcessor)
    .service("terminationsProcessor", TerminationsProcessor)
    .name
